import React from 'react';

export default ({theme = 'default', value, label, ...rest}) => (
	<label className={`Select Select--${theme}`+(rest.disabled ? ' Select--disabled' : '')}>
		<h6>{label}</h6>
		<select value={value || ''} {...rest}/>
	</label>
);